import {
  EDIT_QUESTIONS_URL,
} from "@/utils/constants/constants";
import axios from "axios";

export default {
  methods: {
    validate_tag_id(tag_id) {
      if (tag_id === null || tag_id === undefined) return null;
      const num = Number(tag_id);
      return Number.isInteger(num) ? num : null;
    },

    open_edit_modal(question, index) {
      const full_question = this.question_list.find(q => q.id === question.id);
      if (!full_question) {
        this.show_error("Question data not found");
        return;
      }

      this.current_edit_question = {
        id: full_question.id,
        question: full_question.question_text || "",
        question_number: full_question.question_number || "",
        question_type: this.get_question_type_id(full_question.question_type),
        is_mandatory: full_question.is_mandatory ? "Yes" : "No",
        show_option_inputs: this.is_select_type(full_question.question_type),
        option_inputs: full_question.multi_select_choices?.map(choice => ({
          choice: choice.choice,
          is_mandatory: Boolean(choice.is_mandatory),
        })) || [],
        data_point_id: full_question.data_point?.id || null,
        selected_tag: full_question.tag?.id || null,
        available_tags: full_question.data_point ? this.get_tags_for_data_point(full_question.data_point.id) : [],
        dependant_questions: this.map_dependent_questions(
          full_question.dependent_questions || [],
          full_question
        )
      };


      this.current_edit_index = index;
      this.show_edit_modal = true;
    },

    get_question_type_id(question_type_string) {
      const question_type = this.question_types.find(type =>
        type.question_type === question_type_string
      );
      return question_type ? question_type.id : "";
    },

    is_select_type(question_type_string) {
      const question_type = this.question_types.find(type =>
        type.question_type === question_type_string
      );
      return question_type ? this.select_types.includes(question_type.question_type) : false;
    },

    map_dependent_questions(dependent_questions, parent_question) {
      return dependent_questions.map(dep => ({
        id: dep.id,
        question_text: dep.question_text || "",
        question_type_id: this.get_question_type_id(dep.question_type),
        data_point_id: dep.data_point?.id || null,
        tag_id: dep.tag?.id || null,
        question_number: dep.question_number || "",
        trigger_condition: dep.trigger_condition || "",
        is_mandatory: dep.is_mandatory || false,
        show_option_inputs: this.is_select_type(dep.question_type),
        options: dep.multi_select_choices?.map(choice => ({ choice: choice.choice })) || [],
        parent_options: parent_question?.multi_select_choices?.map(opt => opt.choice) || [],
        available_tags: dep.data_point ? this.get_tags_for_data_point(dep.data_point.id) : []
      }));
    },

    should_disable_tag_selection(form) {
      return form.selected_tag !== null;
    },

    validate_question_form(form, index) {
      if (!form.question?.trim()) {
        this.show_error(`Question text cannot be empty for form ${index + 1}`);
        return false;
      }
      if (!form.question_type) {
        this.show_error(`Question type cannot be empty for form ${index + 1}`);
        return false;
      }

      if (form.show_option_inputs) {
        const valid_options = this.get_valid_option_inputs(form.option_inputs);
        if (valid_options.length < 2) {
          this.show_error(
            `At least two valid options are required for form ${index + 1}`
          );
          return false;
        }
        if (!this.validate_select_mandatory_options(form.question_type, valid_options, `Question ${index + 1}`)) {
          return false;
        }
      }

      return true;
    },

    validate_dependent_question(dep_question, dep_index, form_index) {
      if (!dep_question.question_text?.trim()) {
        this.show_error(
          `Dependent question text cannot be empty for dependent question ${dep_index + 1
          } in form ${form_index + 1}`
        );
        return false;
      }
      if (!dep_question.question_type_id) {
        this.show_error(
          `Dependent question type cannot be empty for dependent question ${dep_index + 1
          } in form ${form_index + 1}`
        );
        return false;
      }
      if (!dep_question.trigger_condition?.trim()) {
        this.show_error(
          `Trigger condition cannot be empty for dependent question ${dep_index + 1
          } in form ${form_index + 1}`
        );
        return false;
      }

      if (dep_question.show_option_inputs) {
        const valid_dep_options = dep_question.options.filter(opt =>
          opt.choice?.trim()
        );
        if (valid_dep_options.length < 2) {
          this.show_error(
            `At least two valid options are required for dependent question ${dep_index + 1
            } in form ${form_index + 1}`
          );
          return false;
        }
      }

      return true;
    },

    save_edited_question() {
      if (!this.current_edit_question.question.trim()) {
        this.show_error("Question text is required");
        return;
      }

      const dependant_questions = (
        this.current_edit_question.dependant_questions || []
      ).map((dep) => ({
        id: dep.id,
        question_text: dep.question_text.trim(),
        question_type_id: dep.question_type_id,
        data_point_id: dep.data_point_id || null,
        tag_id: this.validate_tag_id(dep.tag_id),
        question_number: dep.question_number || null,
        multi_select_options: dep.show_option_inputs
          ? dep.options
            .filter((opt) => opt.choice?.trim())
            .map((opt) => ({ choice: opt.choice.trim() }))
          : [],
        trigger_condition: dep.trigger_condition.trim(),
        is_mandatory: dep.is_mandatory,
      }));

      const payload = {
        question_id: this.current_edit_question.id,
        question_text: this.current_edit_question.question.trim(),
        question_number: this.current_edit_question.question_number || null,
        question_type_id: this.current_edit_question.question_type,
        is_mandatory: this.current_edit_question.is_mandatory === "Yes",
        form_id: this.form_id || null,
        section_id: this.section_id || null,
        options: this.current_edit_question.show_option_inputs
          ? this.get_valid_option_inputs(this.current_edit_question.option_inputs).map(
            (opt) => ({
              choice: opt.choice.trim(),
              is_mandatory: opt.is_mandatory,
            })
          )
          : [],
        data_point_id: this.current_edit_question.data_point_id || null,
        tag_id: this.validate_tag_id(this.current_edit_question.selected_tag),
        dependant_questions: dependant_questions,
      };

      if (
        this.current_edit_question.show_option_inputs &&
        payload.options.length < 2
      ) {
        this.show_error("At least two valid options are required");
        return;
      }

      if (
        this.current_edit_question.show_option_inputs &&
        !this.validate_select_mandatory_options(
          this.current_edit_question.question_type,
          payload.options,
          "Question"
        )
      ) {
        return;
      }

      for (const [dep_index, dep_question] of (
        this.current_edit_question.dependant_questions || []
      ).entries()) {
        if (!dep_question.question_text?.trim()) {
          this.show_error(
            `Dependent question text is required for dependent question ${dep_index + 1
            }`
          );
          return;
        }
        if (!dep_question.question_type_id) {
          this.show_error(
            `Question type is required for dependent question ${dep_index + 1}`
          );
          return;
        }
        if (!dep_question.trigger_condition?.trim()) {
          this.show_error(
            `Trigger condition is required for dependent question ${dep_index + 1
            }`
          );
          return;
        }

        if (dep_question.show_option_inputs) {
          const valid_options = dep_question.options.filter((opt) =>
            opt.choice?.trim()
          );
          if (valid_options.length < 2) {
            this.show_error(
              `At least two valid options are required for dependent question ${dep_index + 1
              }`
            );
            return;
          }
        }
      }

      axios
        .put(EDIT_QUESTIONS_URL, payload, {
          headers: this.headers,
        })
        .then(() => {
          this.show_success("Question updated successfully");
          this.get_questions();
          // this.close_edit_modal();
        })
        .catch((error) => {
          this.show_error(
            "Failed to update question: " +
            (error.response?.data?.message || error.message)
          );
        });
    }
  }
};